import { Route } from '@angular/router';
import { MainLayoutComponent } from './layout/app-layout/main-layout/main-layout.component';

import { AuthLayoutComponent } from './layout/app-layout/auth-layout/auth-layout.component';
import { Page404Component } from './authentication/page404/page404.component';
import { AccueilComponent } from './accueil/accueil.component';
import { dashboardGuard } from '@core/guard/dashboard.guard';
import { EditerBordereauComponent } from './facturation/editer-bordereau/editer-bordereau.component';
import { editionBordereauGuard } from '@core/guard/edition-bordereau.guard';
import { editionFactureGuard } from '@core/guard/edition-facture.guard';
import { authGuard } from '@core/guard/auth.guard';
import { accueilGuard } from '@core/guard/accueil.guard';
import { autreExamenGuard } from '@core/guard/autre-examen.guard';
import { auxiliaireMedicGuard } from '@core/guard/auxiliaire-medic.guard';
import { bilanSanteGuard } from '@core/guard/bilan-sante.guard';
import { biologieGuard } from '@core/guard/biologie.guard';
import { consultationGuard } from '@core/guard/consultation.guard';
import { dentisterieGuard } from '@core/guard/dentisterie.guard';
import { hospitalisationGuard } from '@core/guard/hospitalisation.guard';
import { kineGuard } from '@core/guard/kine.guard';
import { materniteGuard } from '@core/guard/maternite.guard';
import { optiqueGuard } from '@core/guard/optique.guard';
import { ordonnanceGuard } from '@core/guard/ordonnance.guard';
import { pharmacieGuard } from '@core/guard/pharmacie.guard';
import { procreaGuard } from '@core/guard/procrea.guard';
import { transportMedicaliseGuard } from '@core/guard/transport-medicalise.guard';
import { FormOrdonnanceComponent } from './prestation/prestation-main/form-ordonnance/form-ordonnance.component';
import { MainAuxiliaireMedicComponent } from './prestation/prestation-main/main-auxiliaire-medic/main-auxiliaire-medic.component';
import { MainBilanSanteComponent } from './prestation/prestation-main/main-bilan-sante/main-bilan-sante.component';
import { MainBiologieComponent } from './prestation/prestation-main/main-biologie/main-biologie.component';
import { FormPresLaboComponent } from './prestation/prestation-main/main-biologie/form-pres-labo/form-pres-labo.component';
import { FormExecLaboComponent } from './prestation/prestation-main/main-biologie/form-exec-labo/form-exec-labo.component';
import { FormPresKineComponent } from './prestation/prestation-main/main-kine/form-pres-kine/form-pres-kine.component';
import { FormExecKineComponent } from './prestation/prestation-main/main-kine/form-exec-kine/form-exec-kine.component';
import { FormPresRadioComponent } from './prestation/prestation-main/main-imagerie/form-pres-radio/form-pres-radio.component';
import { FormExecRadioComponent } from './prestation/prestation-main/main-imagerie/form-exec-radio/form-exec-radio.component';
import { FormPresMaterniteComponent } from './prestation/prestation-main/main-maternite/form-pres-maternite/form-pres-maternite.component';
import { FormExecMaterniteComponent } from './prestation/prestation-main/main-maternite/form-exec-maternite/form-exec-maternite.component';
import { FormConsulationOptiqueComponent } from './prestation/prestation-main/main-optique/form-consulation-optique/form-consulation-optique.component';
import { FormPresOptiqueComponent } from './prestation/prestation-main/main-optique/form-pres-optique/form-pres-optique.component';
import { FormExecOptiqueComponent } from './prestation/prestation-main/main-optique/form-exec-optique/form-exec-optique.component';
import { FormConsultationDentaireComponent } from './prestation/prestation-main/main-dentisterie/form-consultation-dentaire/form-consultation-dentaire.component';
import { FormPresDentisterieComponent } from './prestation/prestation-main/main-dentisterie/form-pres-dentisterie/form-pres-dentisterie.component';
import { FormExecDentisterieComponent } from './prestation/prestation-main/main-dentisterie/form-exec-dentisterie/form-exec-dentisterie.component';
import { FormPresTransportMedicaliseComponent } from './prestation/prestation-main/main-transport-medicalise/form-pres-transport-medicalise/form-pres-transport-medicalise.component';
import { FormExecTransportMedicaliseComponent } from './prestation/prestation-main/main-transport-medicalise/form-exec-transport-medicalise/form-exec-transport-medicalise.component';
import { FormPresBilanSanteComponent } from './prestation/prestation-main/main-bilan-sante/form-pres-bilan-sante/form-pres-bilan-sante.component';
import { FormExecBilanSanteComponent } from './prestation/prestation-main/main-bilan-sante/form-exec-bilan-sante/form-exec-bilan-sante.component';
import { FormPresProcreaComponent } from './prestation/prestation-main/main-procrea/form-pres-procrea/form-pres-procrea.component';
import { FormExecProcreaComponent } from './prestation/prestation-main/main-procrea/form-exec-procrea/form-exec-procrea.component';
import { FormPresAuxiliaireMedicComponent } from './prestation/prestation-main/main-auxiliaire-medic/form-pres-auxiliaire-medic/form-pres-auxiliaire-medic.component';
import { FormExecAuxiliaireMedicComponent } from './prestation/prestation-main/main-auxiliaire-medic/form-exec-auxiliaire-medic/form-exec-auxiliaire-medic.component';
import { FormPresAutreExamenComponent } from './prestation/prestation-main/main-autre-examamen/form-pres-autre-examen/form-pres-autre-examen.component';
import { FormExecAutreExamenComponent } from './prestation/prestation-main/main-autre-examamen/form-exec-autre-examen/form-exec-autre-examen.component';
import { MainConsultationComponent } from './prestation/prestation-main/main-consultation/main-consultation.component';
import { MainDentisterieComponent } from './prestation/prestation-main/main-dentisterie/main-dentisterie.component';
import { MainHospitalisationComponent } from './prestation/prestation-main/main-hospitalisation/main-hospitalisation.component';
import { MainKineComponent } from './prestation/prestation-main/main-kine/main-kine.component';
import { MainMaterniteComponent } from './prestation/prestation-main/main-maternite/main-maternite.component';
import { MainOptiqueComponent } from './prestation/prestation-main/main-optique/main-optique.component';
import { MainPharmacieComponent } from './prestation/prestation-main/main-pharmacie/main-pharmacie.component';
import { MainProcreaComponent } from './prestation/prestation-main/main-procrea/main-procrea.component';
import { MainTransportMedicaliseComponent } from './prestation/prestation-main/main-transport-medicalise/main-transport-medicalise.component';
import { imagerieGuard } from '@core/guard/imagerie.guard';
import { MainImagerieComponent } from './prestation/prestation-main/main-imagerie/main-imagerie.component';
import { MainAutreExamamenComponent } from './prestation/prestation-main/main-autre-examamen/main-autre-examamen.component';
import { HistoriqueConsultationComponent } from './prestation/historique-consultation/historique-consultation.component';
import { UtilisateursComponent } from './administration/utilisateurs/utilisateurs.component';
import { administrationGuard } from '@core/guard/administration.guard';

export const APP_ROUTE: Route[] = [
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: '/authentication/signin', pathMatch: 'full' },
      {
          path: 'consultation',
          canActivate:[authGuard,consultationGuard],
          component: MainConsultationComponent
        },
        {
          path: 'ordonnance',
          canActivate:[authGuard,ordonnanceGuard],
          component: FormOrdonnanceComponent
        },
        {
          path: 'pharmacie',
          canActivate:[authGuard,pharmacieGuard],
          component: MainPharmacieComponent
        },
        {
          path: 'biologie',
          canActivate:[authGuard,biologieGuard],
          component: MainBiologieComponent,
          children: [
            { path: '', redirectTo: 'prescription', pathMatch: 'full' },
            { path: 'prescription', component: FormPresLaboComponent },
            { path: 'execution', component: FormExecLaboComponent },
          ]
        },
        {
          path: 'imagerie',
          canActivate:[authGuard,imagerieGuard],
          component: MainImagerieComponent,
          children: [
            { path: '', redirectTo: 'prescription', pathMatch: 'full' },
            { path: 'prescription', component: FormPresRadioComponent },
            { path: 'execution', component: FormExecRadioComponent },
          ]
        },
        {
          path: 'autres-examens',
          canActivate:[authGuard,imagerieGuard],
          component: MainAutreExamamenComponent,
          children: [
            { path: '', redirectTo: 'prescription', pathMatch: 'full' },
            { path: 'prescription', component: FormPresAutreExamenComponent },
            { path: 'execution', component: FormExecAutreExamenComponent },
          ]
        },
        {
          path: 'kine',
          canActivate:[authGuard,kineGuard],
          component: MainKineComponent,
          children: [
            { path: '', redirectTo: 'prescription', pathMatch: 'full' },
            { path: 'prescription', component: FormPresKineComponent },
            { path: 'execution', component: FormExecKineComponent },
          ]
        },
        {
          path: 'hospitalisation',
          canActivate:[authGuard,hospitalisationGuard],
          component: MainHospitalisationComponent
        },
        {
          path: 'maternite',
          canActivate:[authGuard,materniteGuard],
          component: MainMaterniteComponent,
          children: [
            { path: '', redirectTo: 'prescription', pathMatch: 'full' },
            { path: 'prescription', component: FormPresMaterniteComponent },
            { path: 'execution', component: FormExecMaterniteComponent },
          ]
        },
        {
          path: 'optique',
          canActivate:[authGuard,optiqueGuard],
          component: MainOptiqueComponent,
          children: [
            { path: '', redirectTo: 'consultation', pathMatch: 'full' },
            { path: 'consultation', component: FormConsulationOptiqueComponent },
            { path: 'prescription', component: FormPresOptiqueComponent },
            { path: 'execution', component: FormExecOptiqueComponent },
          ]
        },
        {
          path: 'dentisterie',
          canActivate:[authGuard,dentisterieGuard],
          component: MainDentisterieComponent,
          children: [
            { path: '', redirectTo: 'consultation', pathMatch: 'full' },
            { path: 'consultation', component: FormConsultationDentaireComponent },
            { path: 'prescription', component: FormPresDentisterieComponent },
            { path: 'execution', component: FormExecDentisterieComponent },
          ]
        },
        {
          path: 'transport-medicalise',
          canActivate:[authGuard,transportMedicaliseGuard],
          component: MainTransportMedicaliseComponent,
          children: [
            { path: '', redirectTo: 'prescription', pathMatch: 'full' },
            { path: 'prescription', component: FormPresTransportMedicaliseComponent },
            { path: 'execution', component: FormExecTransportMedicaliseComponent },
          ]
        },
        {
          path: 'bilan-de-sante',
          canActivate:[authGuard,bilanSanteGuard],
          component: MainBilanSanteComponent,
          children: [
            { path: '', redirectTo: 'prescription', pathMatch: 'full' },
            { path: 'prescription', component: FormPresBilanSanteComponent },
            { path: 'execution', component: FormExecBilanSanteComponent },
          ]
        },
        {
          path: 'procrea',
          canActivate:[authGuard,procreaGuard],
          component: MainProcreaComponent,
          children: [
            { path: '', redirectTo: 'prescription', pathMatch: 'full' },
            { path: 'prescription', component: FormPresProcreaComponent },
            { path: 'execution', component: FormExecProcreaComponent },
          ]
        },
        {
          path: 'auxiliaires-medicaux',
          canActivate:[authGuard,auxiliaireMedicGuard],
          component: MainAuxiliaireMedicComponent,
          children: [
            { path: '', redirectTo: 'prescription', pathMatch: 'full' },
            { path: 'prescription', component: FormPresAuxiliaireMedicComponent },
            { path: 'execution', component: FormExecAuxiliaireMedicComponent },
          ]
        },
        

      {
        path: 'accueil',
        canActivate: [authGuard,accueilGuard],
        component:AccueilComponent
      },
      {
        path: 'dashboard',
        canActivate: [authGuard,dashboardGuard],
        loadChildren: () =>
          import('./dashboard/dashboard.routes').then((m) => m.DASHBOARD_ROUTE),
      },
      {
        path: 'accueil',
        canActivate: [authGuard,dashboardGuard],
        component:AccueilComponent
      },
     
      {
        path: 'historique-consultation',
        canActivate: [authGuard],
        component: HistoriqueConsultationComponent,
      },
      {
        path: 'administration/utilisateurs',
        canActivate: [authGuard, administrationGuard],
        component: UtilisateursComponent,
      },
      {
        path: 'facturation',
        // canActivate: [authGuard,editionFactureGuard],
        loadChildren: () =>
          import('./facturation/facturation.routes').then(
            (m) => m.FACTURATION_ROUTE
          ),
      },
      {
        path: 'decompte-hospit',
        canActivate: [authGuard,editionFactureGuard],
        loadChildren: () =>
          import('./decompte-hospit/decompte-hospit.routes').then(
            (m) => m.DECOMPTE_ROUTE
          ),
      },
      
           
      {
        path: 'comptabilite',
        canActivate: [authGuard],
        loadChildren: () =>
          import('./comptabilite/comptabilite.routes').then(
            (m) => m.COMPTABILITE_ROUTE
          ),
      },
      {
        path: 'decompte-hospit',
        canActivate: [authGuard],
        loadChildren: () =>
          import('./comptabilite/comptabilite.routes').then(
            (m) => m.COMPTABILITE_ROUTE
          ),
      },
      
    ],
  },
  {
    path: 'authentication',
    component: AuthLayoutComponent,
    loadChildren: () =>
      import('./authentication/auth.routes').then((m) => m.AUTH_ROUTE),
  },
  { path: '**', component: Page404Component },
];
